<template>
  <div class="container page usdt-page">
    <van-nav-bar title="綁定USDT" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="form-box">
      <div class="line-item protocol-trc">
        <span class="line-label">trc20:</span>
        <input v-model.trim="trc20Address" class="line-input" type="text" placeholder="請輸入TRC20地址" />
      </div>
      <div class="line-item protocol-erc">
        <span class="line-label">erc20:</span>
        <input v-model.trim="erc20Address" class="line-input" type="text" placeholder="請輸入ERC20地址" />
      </div>
    </div>

    <button type="button" class="save-btn" @click="openPasswordDialog">添加</button>

    <van-dialog
      v-model="showDialog"
      title="請輸入提款密碼"
      show-cancel-button
      cancel-button-text="取消"
      confirm-button-text="確認"
      @confirm="confirmSubmit"
    >
      <van-field
        v-model.trim="password"
        type="password"
        placeholder="提款密碼"
      />
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      trc20Address: '',
      erc20Address: '',
      password: '',
      showDialog: false,
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    async saveSingleAddress(protocol) {
      const address = protocol === 'TRC20' ? this.trc20Address : this.erc20Address;
      if (!address || !address.trim()) {
        return;
      }
      return this.$http({
        method: 'post',
        url: 'user_set_usdt_address',
        data: {
          protocol: protocol,
          address: address.trim(),
          password: this.password.trim(),
        },
      });
    },
    openPasswordDialog() {
      if (!this.trc20Address && !this.erc20Address) {
        this.$toast('請至少輸入一個地址');
        return;
      }
      this.showDialog = true;
    },
    async confirmSubmit() {
      if (!this.password) {
        this.$toast('請輸入提款密碼');
        return false;
      }
      const results = [];
      const trcRes = await this.saveSingleAddress('TRC20');
      if (trcRes) results.push(trcRes);
      const ercRes = await this.saveSingleAddress('ERC20');
      if (ercRes) results.push(ercRes);

      const failed = results.find((r) => r.code !== 200);
      if (failed) {
        this.$toast(failed.msg || '保存失敗');
        return;
      }
      if (results.length) {
        this.$toast.success('添加成功');
        this.password = '';
        this.getUsdtInfo();
      }
    },
    async getUsdtInfo() {
      const res = await this.$http({
        method: 'get',
        url: 'user_get_usdt_info',
      });
      if (res.code !== 200) {
        this.$toast(res.msg || '讀取USDT資訊失敗');
        return;
      }
      const map = (res.data && res.data.protocol_map) ? res.data.protocol_map : {};
      this.trc20Address = map.TRC20 || '';
      this.erc20Address = map.ERC20 || '';
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
      return;
    }
    this.getUsdtInfo();
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

@grad-start: #f560cd;
@grad-end: #4f2b8a;

.usdt-page {
  background: #f3f3f5;
  min-height: 100%;
}

.nav-bar {
  position: relative;
}

.nav-bar::v-deep .van-nav-bar {
  background: linear-gradient(90deg, @grad-start, @grad-end);
}

.nav-bar::v-deep .van-nav-bar::after {
  display: none;
}

.nav-bar::v-deep .van-nav-bar__title {
  max-width: 70%;
  color: #fff;
  font-size: 36px;
  font-weight: 600;
}

.nav-bar::v-deep .van-icon {
  font-size: 40px;
}

.form-box {
  margin-top: 0;
  background: #fff;
}

.line-item {
  display: grid;
  grid-template-columns: 74px 1fr;
  column-gap: 10px;
  align-items: center;
  min-height: 56px;
  padding: 14px 18px;
  box-sizing: border-box;
  border-bottom: 1px solid #e8e8e8;
}

.line-item:last-child {
  border-bottom: 1px solid #e8e8e8;
}

.usdt-page .form-box .line-item.protocol-trc .line-label,
.usdt-page .form-box .line-item.protocol-trc .line-input {
  color: #1989fa !important;
  text-align: left !important;
}

.usdt-page .form-box .line-item.protocol-trc .line-input::placeholder {
  color: rgba(25, 137, 250, 0.5);
}

.line-label {
  width: 74px;
  color: #111;
  font-size: 28px;
  font-weight: 400;
  text-align: left;
}

.line-input {
  width: 100%;
  border: none;
  outline: none;
  font-size: 28px;
  line-height: 1.2;
  color: #111;
  background: transparent;
  text-align: left;
}

.line-input::placeholder {
  color: #999;
}

.save-btn {
  margin: 44px auto 0;
  display: block;
  width: calc(100% - 48px);
  height: 52px;
  border: none;
  border-radius: 12px;
  color: #fff;
  font-size: 34px;
  font-weight: 500;
  line-height: 52px;
  text-align: center;
  background: linear-gradient(90deg, @grad-start, @grad-end);
  box-shadow: 0 4px 14px rgba(79, 43, 138, 0.25);
}

.usdt-page::v-deep .van-field__control {
  font-size: 28px;
}

.usdt-page::v-deep .van-dialog__header {
  font-size: 30px;
  font-weight: 600;
}

.usdt-page::v-deep .van-dialog__confirm,
.usdt-page::v-deep .van-dialog__cancel {
  font-size: 28px;
}
</style>
